namespace GeniuzPOS.InitialData {
    export interface PsDiscCouponTypeMbRow {
        Id?: number;
        DiscCouponType?: string;
        MbType?: string;
    }

    export namespace PsDiscCouponTypeMbRow {
        export const idProperty = 'Id';
        export const nameProperty = 'DiscCouponType';
        export const localTextPrefix = 'InitialData.PsDiscCouponTypeMb';
        export const deletePermission = '1POSBASE:ข้อมูลอ้างอิง:ประเภทการรับเงิน,คูปอง:ประเภทคูปองส่วนลด:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลอ้างอิง:ประเภทการรับเงิน,คูปอง:ประเภทคูปองส่วนลด:Modify';
        export const readPermission = '1POSBASE:ข้อมูลอ้างอิง:ประเภทการรับเงิน,คูปอง:ประเภทคูปองส่วนลด:View';
        export const updatePermission = '1POSBASE:ข้อมูลอ้างอิง:ประเภทการรับเงิน,คูปอง:ประเภทคูปองส่วนลด:Modify';

        export declare const enum Fields {
            Id = "Id",
            DiscCouponType = "DiscCouponType",
            MbType = "MbType"
        }
    }
}
